module.exports = {
    merchantHosted: {
        productDetailPriceNotice: 'In-store price. Prices may differ for online purchases.',
        productDetailPriceDisclaimer: 'Online range and prices shown',
        displayProductTags: true,
        storeChangerModalTitle: 'Change your store',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/merchant-hosted.js